import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=1c20d6a8&"
import script from "./backToTop.vue?vue&type=script&lang=js&"
export * from "./backToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports